import {DividendType, dividendTypeName} from "../../types/DividendType";
import {IFilterFunction} from "angular";

export const DividendTypeNamePipe = "tfDividendTypeName";

export function dividendTypeNamePipe(): IFilterFunction {
    return (type: DividendType | null) => {
        if (type == null) {
            return null;
        } else {
            return dividendTypeName(type);
        }
    };
}
